export default __webpack_public_path__ + "static/media/Buick-White.079ca083.png";